import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarEquivalenciasPaginado,
  type ListarEquivalenciasParams,
} from "../services/equivalencias-service";

/**
 * Listado PAGINADO server-side · query options compartidas entre el loader del
 * route y el componente. Key local · extiende qk.adminEquivalenciasUnidad para
 * que los invalidate de las mutations sigan alcanzando por prefijo.
 */
export const equivalenciasAdminQueryOptions = (params: ListarEquivalenciasParams = {}) =>
  queryOptions({
    queryKey: [...qk.adminEquivalenciasUnidad, "paginado", params] as const,
    queryFn: () => listarEquivalenciasPaginado(params),
    placeholderData: keepPreviousData,
  });

export function useEquivalenciasAdmin(params: ListarEquivalenciasParams = {}) {
  return useQuery(equivalenciasAdminQueryOptions(params));
}
